import { render, staticRenderFns } from "./NYJDownload.vue?vue&type=template&id=2e93a97b&"
import script from "./NYJDownload.vue?vue&type=script&lang=js&"
export * from "./NYJDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports